export default function SRReportTypesController() { /* provided only for controllerAs binding */ }
